import { render, staticRenderFns } from "./RiskCheckCheckLogPartner.vue?vue&type=template&id=0b83fbfe&scoped=true&"
import script from "./RiskCheckCheckLogPartner.vue?vue&type=script&lang=js&"
export * from "./RiskCheckCheckLogPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b83fbfe",
  null
  
)

export default component.exports